function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#828898",
  d: "M20.488 22C22.833 22 24 20.828 24 18.485V7.449c0-2.344-1.167-3.503-3.512-3.503h-2.334V3.24c0-2.236-1.108-3.24-3.206-3.24H9.052C7.06 0 5.846 1.004 5.846 3.24v.706H3.512C1.18 3.946 0 5.106 0 7.449v11.036C0 20.828 1.179 22 3.512 22h16.976zM16.315 3.946h-8.63v-.85c0-.908.46-1.362 1.355-1.362h5.92c.895 0 1.355.454 1.355 1.363v.849zm5.74 6.54H1.945V7.533c0-1.112.554-1.662 1.603-1.662h16.904c1.05 0 1.603.55 1.603 1.662v2.953zm-1.603 9.577H3.548c-1.05 0-1.603-.55-1.603-1.662v-6.134h7.153v.682c0 .944.542 1.494 1.496 1.494h2.812c.942 0 1.496-.55 1.496-1.494v-.682h7.153v6.134c0 1.112-.554 1.662-1.603 1.662z"
});

function SvgNewJobs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewJobs);
export default __webpack_public_path__ + "static/media/new-jobs.9209a7ba.svg";
export { ForwardRef as ReactComponent };